import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  it: {
    "nav.armocromia": "Armocromia",
    "nav.makeup": "Make-up",
    "nav.skincare": "Skincare",
    "nav.fashion": "Fashion",
    "nav.outfits": "Outfit",
    "nav.hair": "Capelli",
    "nav.quiz": "Fai il Quiz",
    "nav.login": "Accedi",
    "nav.dashboard": "Il mio profilo",
    "nav.admin": "Admin",
    "nav.logout": "Esci",
    "common.discover": "Scopri",
    "common.viewAll": "Vedi tutto",
    "common.buy": "Acquista",
    "common.match": "Compatibilità",
    "common.start": "Inizia ora",
    "common.next": "Avanti",
    "common.back": "Indietro",
    "common.results": "Vedi i risultati",
    "common.loading": "Caricamento...",
    "common.save": "Salva",
    "common.filters": "Filtri",
    "common.all": "Tutti",
    "common.brand": "Brand",
    "common.price": "Prezzo",
    "hero.tag": "Il tuo consulente personale di bellezza & stile",
    "hero.title": "Scopri i colori, i prodotti e gli stili perfetti per te",
    "hero.sub": "Analisi armocromia professionale, avatar dinamico e migliaia di prodotti consigliati su misura. Senza costi, in pochi secondi.",
    "hero.cta": "Crea il tuo profilo",
    "hero.cta2": "Esplora i cataloghi",
    "results.title": "La tua stagione armocromatica",
    "results.palette": "La tua palette",
    "results.avoid": "Colori da evitare",
    "results.makeup": "Trucco ideale",
    "results.clothes": "Abbigliamento ideale",
    "results.accessories": "Accessori",
    "results.jewelry": "Gioielli",
    "results.hair": "Capelli consigliati",
    "results.recos": "I prodotti più adatti a te",
    "quiz.title": "Configura il tuo profilo",
    "quiz.sub": "Rispondi alle domande per ricevere consigli personalizzati",
  },
  en: {
    "nav.armocromia": "Color Analysis",
    "nav.makeup": "Make-up",
    "nav.skincare": "Skincare",
    "nav.fashion": "Fashion",
    "nav.outfits": "Outfits",
    "nav.hair": "Hair",
    "nav.quiz": "Take the Quiz",
    "nav.login": "Sign in",
    "nav.dashboard": "My profile",
    "nav.admin": "Admin",
    "nav.logout": "Log out",
    "common.discover": "Discover",
    "common.viewAll": "View all",
    "common.buy": "Shop",
    "common.match": "Match",
    "common.start": "Start now",
    "common.next": "Next",
    "common.back": "Back",
    "common.results": "See results",
    "common.loading": "Loading...",
    "common.save": "Save",
    "common.filters": "Filters",
    "common.all": "All",
    "common.brand": "Brand",
    "common.price": "Price",
    "hero.tag": "Your personal beauty & style consultant",
    "hero.title": "Discover the perfect colors, products and styles for you",
    "hero.sub": "Professional color analysis, a dynamic avatar and thousands of tailored product picks. Free, in seconds.",
    "hero.cta": "Create your profile",
    "hero.cta2": "Explore catalogs",
    "results.title": "Your color season",
    "results.palette": "Your palette",
    "results.avoid": "Colors to avoid",
    "results.makeup": "Ideal makeup",
    "results.clothes": "Ideal clothing",
    "results.accessories": "Accessories",
    "results.jewelry": "Jewelry",
    "results.hair": "Recommended hair",
    "results.recos": "Products best suited to you",
    "quiz.title": "Set up your profile",
    "quiz.sub": "Answer a few questions to get personalized advice",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("velyrea_lang") || "it");
  const t = useCallback((key) => dict[lang][key] || dict.it[key] || key, [lang]);
  const toggle = useCallback(() => {
    setLang((l) => {
      const nl = l === "it" ? "en" : "it";
      localStorage.setItem("velyrea_lang", nl);
      return nl;
    });
  }, []);
  const L = useCallback((obj, field) => {
    if (!obj) return "";
    return obj[`${field}_${lang}`] ?? obj[`${field}_it`] ?? obj[field] ?? "";
  }, [lang]);
  return <I18nContext.Provider value={{ lang, t, toggle, L, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
